<template>
  <section>
    <el-select :value="label" placeholder="请选择上级岗位" ref="select" :clearable="true" @clear="doClear">
      <el-option :value="id" :label="label">
        <el-tree id="tree-option"
                 ref="selectTree"
                 :data="roleList"
                 :props="defaultProps"
                 :node-key="defaultProps.value"
                 :default-expanded-keys="defaultExpandedKey"
                 @node-click="handleNodeClick"
                 :load="loadNode1"
                 :default-expand-all="true"
                 :expand-on-click-node="false"
                 lazy
        >
        </el-tree>
      </el-option>
    </el-select>
  </section>
</template>
<script>
  import {roleChildren} from '../../api/api'

  export default {
    name: 'CompanyTree',
    props: {
      roleList:Array,
      roleId:null,
      roleName:null,
      currentId:null,
      option:0,
      comId:null,
    },
    data() {
      return {
        //选择树==============================
        data: [],
        defaultProps: {
          children: 'children',
          label:
            'roleName',
          value:
            'id',
          disabled: 'disabled'
        },
        id: null,
        label: null,
        defaultExpandedKey: [],
        //====选择树结束=================
      }
    },
    methods: {
      //选择树==================================================================
      //加载数据
      loadNode1(node, resolve) {
        let roleId = 0;
        if (node.level > 0) {
          roleId = node.key;
          let params = {parentId: roleId,comId:this.comId};//请求参数
          roleChildren(params, this.GLOBAL.header).then(result => {
            if (result.success) {
              return resolve(result.data)
            }
          });
        }
      },
      // 切换选项
      handleNodeClick(data,node,self) {
        if(this.option==1){
          let p = node.parent;
          while(p!=null){
            if(p.key == this.currentId){
              this.$message({
                message: "不能选择下级岗位作为上级",
                type: 'error'
              });
              return;
            }
            p = p.parent;
          }
          if (data.id == this.currentId) {
            this.$message({
              message: "不能选择自己作为上级",
              type: 'error'
            });
            return ;
          }
        }
        this.label = data.roleName;
        this.id = data.id;
        this.$emit('roleSelected', data.id, data.roleName);
      },
      //选择树结束==============================
      doClear: function () {
        this.label = null;
        this.id = null;
        this.$emit('roleSelected',this.id, this.label);
      }
    },
    mounted() {
      if (this.option==1) {
        this.id = this.roleId;
        this.label = this.roleName;
      }
      this.$emit('roleSelected',this.id, this.label);
    }
  }
</script>

<style scoped>
  /*选择树================================*/
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
    height: auto;
    max-height: 274px;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }

  .el-select-dropdown__item.selected {
    font-weight: normal;
  }

  ul li >>> .el-tree .el-tree-node__content {
    height: auto;
    padding: 0 20px;
  }

  .el-tree-node__label {
    font-weight: normal;
  }

  .el-tree >>> .is-current .el-tree-node__label {
    color: #409EFF;
    font-weight: 700;
  }

  .el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
    color: #606266;
    font-weight: normal;
  }

  /*选择树================================*/
</style>



// WEBPACK FOOTER //
// src/components/sysmanager/RoleList.vue